import { Theme } from '@mui/material/styles';

export default function MuiXDateRangePicker(theme: Theme) {
  return {
    MuiDateRangeCalendar: {
      styleOverrides: {
        root: {
          '& div[style="position: absolute; pointer-events: none; color: rgba(130, 130, 130, 0.62); z-index: 100000; width: 100%; text-align: center; bottom: 50%; right: 0px; letter-spacing: 5px; font-size: 24px;"]':
            {
              display: 'none',
            },
        },
      },
    },
  };
}
